import React, { useState } from "react";
import "./gallery.css";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import {
  portfolioImg,
  logosImg,
  menusImg,
  miscImg,
  webImg,
  printImg,
  gamesImg,
} from "../img/portfolioImages.js";

const Gallery = () => {
  const [selection, setSelection] = useState(portfolioImg);
  const [model, setModel] = useState(false);
  const [tempImgSource, setTempImgSource] = useState(null);

  const getImg = (imgSrc) => {
    // console.warn(imgSrc);
    setTempImgSource(imgSrc);
    setModel(true);
  };

  function handleClick(selected) {
    setSelection(selected);
  }

  return (
    <>
      <h1>Show me the goods!</h1>

      <div className="gallery-menu">
        <Button onClick={() => handleClick(portfolioImg)} variant="outlined" disabled={selection === portfolioImg ? true : false}>
          Portfolio
        </Button>
        <Button onClick={() => handleClick(logosImg)} variant="outlined" disabled={selection === logosImg ? true : false}>
          Logos
        </Button>
        <Button onClick={() => handleClick(printImg)} variant="outlined" disabled={selection === printImg ? true : false}>
          Print
        </Button>
        <Button onClick={() => handleClick(miscImg)} variant="outlined" disabled={selection === miscImg ? true : false}>
          Misc
        </Button>
        <Button onClick={() => handleClick(webImg)} variant="outlined" disabled={selection === webImg ? true : false}>
          Web
        </Button>
        <Button onClick={() => handleClick(menusImg)} variant="outlined" disabled={selection === menusImg ? true : false}>
          Menus
        </Button>
        <Button onClick={() => handleClick(gamesImg)} variant="outlined" disabled={selection === gamesImg ? true : false}>
          Games
        </Button>
      </div>
      <div className={model ? "model open" : "model"}>
        <img src={tempImgSource} />
        <CloseIcon onClick={() => setModel(false)} />
      </div>

      <div className="gallery">
        {selection.map((item, index) => {
          return (
            <div
              className="pics"
              key={index}
              onClick={() => getImg(item.imgSrc)}
            >
              <img src={item.imgSrc} style={{ width: "100%" }} />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Gallery;
